import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const loginRoutes = [{
  path: '',
  name: 'login',
  component: () => import('../views/login/login.vue'),
}]

const printRoutes = [{
  path: '/feeReceiptPrint',
  name: 'feeReceiptPrint',
  component: () => import('../views/feeManagement/feeQuery/feeReceiptPrint.vue')
}]

const manageRoutes = [{
  path: '/manage',
  name: '',
  redirect: {
    name: 'homePage'
  },
  component: () => import('../views/manage.vue'),
  children: [
    // 首页
    {
      path: '/manage/homePage',
      name: 'homePage',
      meta: {
        name: '首页',
        icon: 'el-icon-star-off',
      },
      component: () => import('../views/homePage.vue'),
    },
    // 个人信息
    {
      path: '/manage/personalInfo',
      name: 'personalInfo',
      meta: {
        name: '个人信息',
        icon: 'el-icon-star-off',
      },
      component: () => import('../components/personalInfo.vue'),
    },
    // 业主APP服务
    {
      path: '/manage/ownerAppService',
      name: 'ownerAppService',
      meta: {
        name: '业主APP服务',
        icon: 'el-icon-star-off',
      },
      redirect: {
        name: 'neighborView'
      },
      component: () => import('../views/ownerAppService/ownerAppService.vue'),
    },
    // 众邻观点
    {
      path: '/manage/main.courtroomList',
      name: 'neighborView',
      // redirect: {
      //   name: 'neighborList'
      // },
      meta: {
        name: '众邻观点',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/neighborViews/neighborViewlist.vue'),
    },
    // 添加众邻观点
    {
      path: '/manage/neighborViewAdd',
      name: 'addNeighbor',
      meta: {
        name: '添加众邻观点',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/neighborViews/neighborViewEdit.vue')
    },
    // 修改众邻观点
    {
      path: '/manage/neighborViewEdit',
      name: 'editNeighbor',
      meta: {
        name: '修改众邻观点',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/neighborViews/neighborViewEdit.vue')
    },
    // 参加投票用户
    {
      path: '/manage/votingUsersList',
      name: 'votingUsersList',
      meta: {
        name: '参加投票用户',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/neighborViews/votingUsersList.vue')
    },
    // APP布局
    {
      path: '/manage/main.appplotList',
      name: 'appplotList',
      meta: {
        name: 'APP布局',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appplot/appplotList.vue')
    },
    // 新增APP布局
    {
      path: '/manage/appplotAdd',
      name: 'appplotAdd',
      meta: {
        name: '新增APP布局',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appplot/appplotEdit.vue')
    },
    // 修改APP布局
    {
      path: '/manage/appplotEdit',
      name: 'appplotEdit',
      meta: {
        name: '修改APP布局',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appplot/appplotEdit.vue')
    },
    // 服务小站管理
    {
      path: '/manage/main.appletsGoodList',
      name: 'appletsGoodList',
      meta: {
        name: '服务小站管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appletsGood/appletsGoodList.vue')
    },
    // 新增服务小站
    {
      path: '/manage/appletsGoodAdd',
      name: 'appletsGoodAdd',
      meta: {
        name: '新增服务小站',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appletsGood/appletsGoodEdit.vue')
    },
    // 修改服务小站
    {
      path: '/manage/appletsGoodEdit',
      name: 'appletsGoodEdit',
      meta: {
        name: '修改服务小站',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/appletsGood/appletsGoodEdit.vue')
    },
    // 专属二维码
    {
      path: '/manage/main.qrcode',
      name: 'qrcodeList',
      meta: {
        name: '专属二维码',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/qrcode/qrcodeList.vue')
    },
    // 新增专属二维码
    {
      path: '/manage/qrcodeAdd',
      name: 'qrcodeAdd',
      meta: {
        name: '新增专属二维码',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/qrcode/qrcodeEdit.vue')
    },
    // 修改专属二维码
    {
      path: '/manage/qrcodeEdit',
      name: 'qrcodeEdit',
      meta: {
        name: '修改专属二维码',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/qrcode/qrcodeEdit.vue')
    },
    // 业主app服务-标签管理
    {
      path: '/manage/main.tabList',
      name: 'label',
      meta: {
        name: '标签管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/labelManagement/label.vue')
    },
    // 业主app服务-发帖审核
    {
      path: '/manage/main.topics',
      name: 'postAuditsList',
      meta: {
        name: '发帖审核',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/postAudits/postAuditList.vue')
    },
    // 业主app服务-周边服务
    {
      path: '/manage/main.gardenservice',
      name: 'peripheralList',
      meta: {
        name: '周边服务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/peripherals/peripheralList.vue')
    },
    // 业主app服务-新增周边服务
    {
      path: '/manage/peripheralAdd',
      name: 'peripheralAdd',
      meta: {
        name: '新增周边服务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/peripherals/peripheralEdit.vue')
    },
    // 业主app服务-修改周边服务
    {
      path: '/manage/peripheralEdit',
      name: 'peripheralEdit',
      meta: {
        name: '修改周边服务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/ownerAppService/peripherals/peripheralEdit.vue')
    },
    // 业主通知
    {
      path: '/manage/main.unotice',
      name: 'proprietorNotificationList',
      meta: {
        name: '业主通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationList.vue')
    },
    // 添加通知
    {
      path: '/manage/proprietorNotificationAdd',
      name: 'proprietorNotificationAdd',
      meta: {
        name: '添加通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationEdit.vue')
    },
    // 编辑通知
    {
      path: '/manage/proprietorNotificationEdit',
      name: 'proprietorNotificationEdit',
      meta: {
        name: '编辑通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationEdit.vue')
    },
    // 业主私信
    {
      path: '/manage/main.privateLetter',
      name: 'proprietorPrivateletterList',
      meta: {
        name: '业主私信',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorPrivateletter/proprietorPrivateletterList.vue')
    },
    // APP住户管理
    {
      path: '/manage/main.user',
      name: 'appHouseholdManageList',
      meta: {
        name: 'APP住户管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/appHouseholdManageList.vue')
    },
    // 识别主体管理
    {
      path: '/manage/main.woUser',
      name: 'woAppHouseholdManageList',
      meta: {
        name: '人像注册',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/woAppHouseholdManageList.vue')
    },
    // 人脸识别授权
    {
      path: '/manage/main.woUserAuth',
      name: 'woAppAuthHouseholdManageList',
      meta: {
        name: '人脸识别授权',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/woAppAuthHouseholdManageList.vue')
    },
    // 人脸识别授权详情
    {
      path: '/manage/main.woAppAuthHouseholdManageDetail',
      name: 'woAppAuthHouseholdManageDetail',
      meta: {
        name: '识别主体管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/woAppAuthHouseholdManageDetail.vue')
    },
    // 查看住户
    {
      path: '/manage/houseHoldInfo',
      name: 'houseHoldInfo',
      meta: {
        name: '查看住户',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/houseHoldInfo.vue')
    },
    // app业主画像
    {
      path: '/manage/appHouseholdPortrait',
      name: 'appHouseholdPortrait',
      meta: {
        name: '业主画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appHouseholdManages/appHouseholdPortrait.vue')
    },
    // APP积分管理
    {
      path: '/manage/main.integral',
      name: 'appIntegralManagesList',
      meta: {
        name: 'APP积分管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appIntegralManages/appIntegralManagesList.vue')
    },
    // APP订单管理
    {
      path: '/manage/main.appOrder',
      name: 'appOrderManagesList',
      meta: {
        name: 'APP订单管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/appOrderManages/appOrderManagesList.vue')
    },
    // 小区空置房管理
    {
      path: '/manage/main.gardenvacant1',
      name: 'vacantHouseManagementList',
      meta: {
        name: '小区空置房管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/vacantHouseManagement/vacantHouseManagementList.vue')
    },
    // 原始住户数据管理
    {
      path: '/manage/main.roomOwner',
      name: 'preHouseholdInfoManageList',
      meta: {
        name: '原始住户数据管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/preHouseholdInfoManageList.vue')
    },
    {
      path: '/manage/main.propertyCar',
      name: 'propertyCarManageList',
      meta: {
        name: '车位数据管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/propertyCarManageList.vue')
    },
    {
      path: '/manage/main.transferLogs',
      name: 'transferLogs',
      meta: {
        name: '房屋车位转让日志',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/propertyCarRecordList.vue')
    },
    // 新增原始数据
    {
      path: '/manage/addPreInfo',
      name: 'addPreInfo',
      meta: {
        name: '新增原始数据',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/editPreInfo.vue')
    },
    // 新增车主信息
    {
      path: '/manage/addPreInfoCar',
      name: 'addPreInfoCar',
      meta: {
        name: '车主信息管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/editPreInfoCar.vue')
    },
    // 修改原始数据
    {
      path: '/manage/editPreInfo',
      name: 'editPreInfo',
      meta: {
        name: '修改原始数据',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/editPreInfo.vue')
    },
    {
      path: '/manage/carPlaceInfo',
      name: 'carPlaceInfo',
      meta: {
        name: '原始数据车位',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/carPlaceInfo.vue')
    },
    {
      path: '/manage/waterInfo',
      name: 'waterInfo',
      meta: {
        name: '仪表数据',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/waterInfo.vue')
    },
    {
      path: '/manage/rentInfo',
      name: 'rentInfo',
      meta: {
        name: '租赁信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/rentInfo.vue')
    },
    {
      path: '/manage/tenants',
      name: 'tenants',
      meta: {
        name: '原始数据租户',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/preHouseholdInfoManages/tenants.vue')
    },
    // 小区信息管理
    {
      path: '/manage/main.garden1',
      name: 'communityInfoManageList',
      meta: {
        name: '项目信息管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/communityInfoManages/communityInfoManageList.vue')
    },
    // 物业周检问题
    {
      path: '/manage/main.weeklyInspectionList',
      name: 'propertyWeekInspectList',
      meta: {
        name: '物业周检问题',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/propertyWeekInspect/propertyWeekInspectList.vue')
    },
    // 电话信息
    {
      path: '/manage/main.contact',
      name: 'teleInfoList',
      meta: {
        name: '电话信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/teleInfos/teleInfoList.vue')
    },
    // 车场管理
    {
      path: '/manage/main.carPackList',
      name: 'carPackList',
      meta: {
        name: '车场管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carPark/carParkList.vue')
    },
    // 车位管理
    {
      path: '/manage/carPlaceList',
      name: 'carPlaceList',
      meta: {
        name: '车位管理 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carPlace/carPlaceList.vue')
    },
    // 月租车收费标准
    {
      path: '/manage/carMonthlyCostList',
      name: 'carMonthlyCostList',
      meta: {
        name: '月租车收费标准',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carMonthlyCost/carMonthlyCostList.vue')
    },
    // 出入口管理
    {
      path: '/manage/carGateList',
      name: 'carGateList',
      meta: {
        name: '出入口管理 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carGate/carGateList.vue')
    },
    // 车辆管理
    {
      path: '/manage/main.carUserList',
      name: 'carUserList',
      meta: {
        name: '车辆管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carUser/carUserList.vue')
    },
    {
      path: '/manage/main.carUserList1',
      name: 'carUserList1',
      meta: {
        name: '车辆管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carUser/carUserList1.vue')
    },
    {
      path: '/manage/main.carStoreList',
      name: 'carStoreList',
      meta: {
        name: '储值卡管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carStore/carStoreList.vue')
    },
    {
      path: '/manage/main.carStoreOrder',
      name: 'carStoreOrder',
      meta: {
        name: '储值卡充值',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carStore/carStoreOrder.vue')
    },
    // 车辆出入记录
    {
      path: '/manage/main.carInOutList',
      name: 'carInOutList',
      meta: {
        name: '月租车出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutList.vue')
    },
    {
      path: '/manage/main.carInOutGuestList',
      name: 'carInOutGuestList',
      meta: {
        name: '访客车出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutGuestList.vue')
    },
    {
      path: '/manage/main.carInOutFixList',
      name: 'carInOutFixList',
      meta: {
        name: '固定车出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutFixList.vue')
    },
    // 月租车数据清理
    {
      path: '/manage/main.carInOutData',
      name: 'carInOutData',
      meta: {
        name: '车辆出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutData.vue')
    },
    // 储值车数据清理
    {
      path: '/manage/main.carInOutStoreData',
      name: 'carInOutStoreData',
      meta: {
        name: '车辆出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutStoreData.vue')
    },
    // 临时车数据清理
    {
      path: '/manage/main.carInOutTmpData',
      name: 'carInOutTmpData',
      meta: {
        name: '车辆出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutTmpData.vue')
    },
    {
      path: '/manage/main.carBlackList',
      name: 'carBlackList',
      meta: {
        name: '车场黑名单管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carBlackList.vue')
    },
    {
      path: '/manage/main.carInOutStoreList',
      name: 'carInOutStoreList',
      meta: {
        name: '储值车出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutStoreList.vue')
    },
    {
      path: '/manage/carStoreOrderList',
      name: 'carStoreOrderList',
      meta: {
        name: '储值卡明细',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carStore/carStoreOrderList.vue')
    },
    {
      path: '/manage/main.carRecordList',
      name: 'carRecordList',
      meta: {
        name: '车场日志',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carRecordList.vue')
    },
    {
      path: '/manage/main.carInOutTmpList',
      name: 'carInOutTmpList',
      meta: {
        name: '临时车出入记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutTmpList.vue')
    },
    {
      path: '/manage/main.carInOutTmpConfirmList',
      name: 'carInOutTmpConfirmList',
      meta: {
        name: '临时车人工确认',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carInOutTmpConfirmList.vue')
    },
    // 车辆发卡 
    {
      path: '/manage/main.carGateRuleList',
      name: 'carGateRuleList',
      meta: {
        name: '车辆发卡',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carGateRule/carGateRuleList.vue')
    },
    // 临期车辆查询
    {
      path: '/manage/main.carEndDateList',
      name: 'carEndDateList',
      meta: {
        name: '车辆管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carUser/carEndDateList.vue')
    },
    {
      path: '/manage/main.carGateRuleList1',
      name: 'carGateRuleList1',
      meta: {
        name: '车辆发卡查询',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carGateRule/carGateRuleList1.vue')
    },
    // 车场监控
    {
      path: '/manage/main.carParkControl',
      name: 'carParkControl',
      meta: {
        name: '车场监控',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carPark/carParkControl.vue')
    },
    // 车场数据管理
    {
      path: '/manage/main.carDataAll',
      name: 'carDataAll',
      meta: {
        name: '车场数据管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carInOut/carDataAll.vue')
    },
    // 摄像头显示
    {
      path: '/manage/carCameraList',
      name: 'carCameraList',
      meta: {
        name: '摄像头显示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/carCamera/carCameraList.vue')
    },
    // 租客审批
    {
      path: '/manage/main.tenantInfoManager',
      name: 'tenantInfoList',
      meta: {
        name: '租客审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/tenantInfos/tenantInfoList.vue')
    },
    // 问卷调查链接
    {
      path: '/manage/main.questionnaireList',
      name: 'questionnaireLinkList',
      meta: {
        name: '问卷调查链接',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/questionnaireLinks/questionnaireLinkList.vue')
    },
    // 车位摇号审批
    {
      path: '/manage/main.parkingLotteryManager',
      name: 'parkingLotteryList',
      meta: {
        name: '车位摇号审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/parkingLottery/parkingLotteryList.vue')
    },
    // 摇号车位管理
    {
      path: '/manage/main.parkingLotteryPlaceManager',
      name: 'parkingLotteryPlaceList',
      meta: {
        name: '摇号车位管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/parkingLotteryPlace/parkingLotteryPlaceList.vue')
    },
    // 业主端APP广告管理
    {
      path: '/manage/main.doorDeviceNoticeList',
      name: 'OwnerAppadvertisingList',
      meta: {
        name: '业主端APP广告管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/OwnerAppadvertisingManagement/OwnerAppadvertisingList.vue')
    },
    // 添加业主APP广告
    {
      path: '/manage/OwnerAppadvertisingadd',
      name: 'OwnerAppadvertisingadd',
      meta: {
        name: '添加业主APP广告 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/OwnerAppadvertisingManagement/OwnerAppadvertisingadd.vue')
    },
    // 积分广告
    {
      path: '/manage/main.pivot1',
      name: 'IntegralADList',
      meta: {
        name: '积分广告',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/IntegralAD/IntegralADList.vue')
    },
    // 添加积分广告
    {
      path: '/manage/IntegralADadd',
      name: 'IntegralADadd',
      meta: {
        name: '添加广告',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/IntegralAD/IntegralADadd.vue')
    },
    // 众乐汇广告管理
    {
      path: '/manage/main.pivot2',
      name: 'AllRemittanceadvertisingManagementList',
      meta: {
        name: '众乐汇广告管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/AllRemittanceadvertisingManagement/AllRemittanceadvertisingManagementList.vue')
    },
    // 添加众乐汇广告管理
    {
      path: '/manage/AllRemittanceadvertisingManagementadd',
      name: 'AllRemittanceadvertisingManagementadd',
      meta: {
        name: '添加广告 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/AllRemittanceadvertisingManagement/AllRemittanceadvertisingManagementadd.vue')
    },
    // 首页广告管理
    {
      path: '/manage/main.pivot0',
      name: 'indexAdvertisingList',
      meta: {
        name: '首页广告管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/indexAdvertising/indexAdvertisingList.vue')
    },
    // 添加首页广告
    {
      path: '/manage/indexAdvertisingadd',
      name: 'indexAdvertisingadd',
      meta: {
        name: '添加广告 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/indexAdvertising/indexAdvertisingadd.vue')
    },
    // 邻里帮广告管理
    {
      path: '/manage/main.pivot3',
      name: 'NeighborhoodStateAdvertisementList',
      meta: {
        name: '邻里帮广告管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/NeighborhoodStateAdvertisement/NeighborhoodStateAdvertisementList.vue')
    },
    // 添加邻里帮广告
    {
      path: '/manage/NeighborhoodStateAdvertisementadd',
      name: 'NeighborhoodStateAdvertisementadd',
      meta: {
        name: '添加广告 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/advertisingManagement/NeighborhoodStateAdvertisement/NeighborhoodStateAdvertisementadd.vue')
    },
    // 400报事信息
    {
      path: '/manage/main.maintainInfo400',
      name: '400NewspaperInfoList',
      meta: {
        name: '400报事信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/400NewspaperInfos/400NewspaperInfoList.vue')
    },
    // 400后台补单
    {
      path: '/manage/400backgroundSupply',
      name: '400backgroundSupply',
      meta: {
        name: '400后台补单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/400NewspaperInfos/400backgroundSupply.vue')
    },
    // 查看报事信息
    {
      path: '/manage/400backgroundDetail',
      name: '400backgroundDetail',
      meta: {
        name: '查看报事信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/400NewspaperInfos/400backgroundDetail.vue')
    },
    // 打印报事
    {
      path: '/manage/print400',
      name: 'print400List',
      meta: {
        name: '打印报事',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/print400/print400List.vue')
    },
    // 全项目报事信息
    {
      path: '/manage/main.allMaintain',
      name: 'projectWideRepoInfoList',
      meta: {
        name: '全项目报事信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/projectWideRepoInfos/projectWideRepoInfoList.vue')
    },
    // 全项目报事信息后台补单
    {
      path: '/manage/projectWideRepoInfoBackgroundSupply',
      name: 'projectWideRepoInfoBackgroundSupply',
      meta: {
        name: '全项目报事信息后台补单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/projectWideRepoInfos/backgroundSupply.vue')
    },
    // 全项目报事详情
    {
      path: '/manage/projectWideRepoInfoBackgroundDetail',
      name: 'projectWideRepoInfoBackgroundDetail',
      meta: {
        name: '全项目报事详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/projectWideRepoInfos/backgroundDetail.vue')
    },
    // 全项目报事详情
    {
      path: '/manage/projectWideRepoInfoBackgroundDetail1',
      name: 'projectWideRepoInfoBackgroundDetail1',
      meta: {
        name: '全项目报事详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/projectWideRepoInfos/backgroundDetail1.vue')
    },
    // 全项目自动巡检报事
    {
      path: '/manage/main.allMaintainQuartzJob',
      name: 'fullprojectAutoInspecRepoList',
      meta: {
        name: '全项目自动巡检报事',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/fullprojectAutoInspecRepos/fullprojectAutoInspecRepoList.vue')
    },
    // 全项目自动巡查后台补单
    {
      path: '/manage/fullprojectAutoInspecRepoBackgroundSupply',
      name: 'fullprojectAutoInspecRepoBackgroundSupply',
      meta: {
        name: '全项目自动巡查后台补单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/fullprojectAutoInspecRepos/backgroundSupply.vue')
    },
    // 全项目自动巡查报事详情
    {
      path: '/manage/fullprojectAutoInspecRepoBackgroundDetail',
      name: 'fullprojectAutoInspecRepoBackgroundDetail',
      meta: {
        name: '全项目自动巡查报事详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/fullprojectAutoInspecRepos/backgroundDetail.vue')
    },
    // 园区鹰眼监控
    {
      path: '/manage/main.supplyVideo',
      name: 'hawkEyeOfParkList',
      meta: {
        name: '园区鹰眼监控',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/hawkEyeOfPark/hawkEyeOfParkList.vue')
    },
    // 项目鹰眼监控
    {
      path: '/manage/main.supplyVideoNew',
      name: 'hawkEyeOfParkListNew',
      meta: {
        name: '项目鹰眼监控',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/hawkEyeOfPark/hawkEyeOfParkListNew.vue')
    },
    // 分类查看鹰眼
    {
      path: '/manage/main.supplyVideoByType',
      name: 'hawkEyeOfParkListByType',
      meta: {
        name: '分类查看鹰眼',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/hawkEyeOfParkByType/hawkEyeOfParkListByType.vue')
    },
    // 抽审工单
    {
      path: '/manage/main.randomInspectionMaintain',
      name: 'trialOrderList',
      meta: {
        name: '抽审工单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/trialOrder/trialOrderList.vue')
    },
    // 抽审记录
    {
      path: '/manage/trialNotes',
      name: 'trialNotes',
      meta: {
        name: '抽审记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/trialOrder/trialNotes.vue')
    },
    // 抽审详情列表
    {
      path: '/manage/trialDetailList',
      name: 'trialDetailList',
      meta: {
        name: '抽审记录详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/trialOrder/trialDetailList.vue')
    },
    {
      path: '/manage/trialDetailList1',
      name: 'trialDetailList1',
      meta: {
        name: '抽审记录详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/trialOrder/trialDetailList1.vue')
    },
    // 抽审工单详情
    {
      path: '/manage/trialOrderDetail',
      name: 'trialOrderDetail',
      meta: {
        name: '抽审详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/trialOrder/trialOrderDetail.vue')
    },
    // 报事信息
    {
      path: '/manage/main.maintainInfo',
      name: 'repoInfoList',
      meta: {
        name: '报事信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/repoInfos/repoInfoList.vue')
    },
    // 报事信息后台补单
    {
      path: '/manage/repoInfoBackgroundSupply',
      name: 'repoInfoBackgroundSupply',
      meta: {
        name: '报事信息后台补单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/repoInfos/backgroundSupply.vue')
    },
    // 报事信息详情
    {
      path: '/manage/repoInfoBackgroundDetail',
      name: 'repoInfoBackgroundDetail',
      meta: {
        name: '报事信息详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/repoInfos/backgroundDetail.vue')
    },
    // 报事类型设置
    {
      path: '/manage/main.maintainType1',
      name: 'maintainTypesList',
      meta: {
        name: '报事类型设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/maintainTypeSetting/maintainTypeManageList.vue')
    },
    // 鹰眼分类
    {
      path: '/manage/main.videoMonitorType',
      name: 'videoMonitorTypeList',
      meta: {
        name: '鹰眼分类',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/videoMonitorType/videoMonitorTypeList.vue')
    },
    // 智能巡更?
    {
      path: '/manage/intelligentPatrol',
      name: 'intelligentPatrol',
      meta: {
        name: '智能巡更',
        icon: 'el-icon-star-off',
      },
      redirect: {
        name: 'personnelAllot'
      },
      component: () => import('../views/intelligentPatrol/intelligentPatrol.vue'),
    },
    // 平面图设置
    {
      path: '/manage/main.planarGraphList',
      name: 'planeLayoutList',
      meta: {
        name: '平面图设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/intelligentPatrol/planeLayouts/planeLayoutList.vue')
    },
    // 点位设置
    {
      path: '/manage/pointSetting',
      name: 'pointSetting',
      meta: {
        name: '点位设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/intelligentPatrol/planeLayouts/pointSetting.vue')
    },
    // 打印二维码
    {
      path: '/manage/main.patrolPointList',
      name: 'printQrCodeList',
      meta: {
        name: '打印二维码',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/printQRCode/printQRCodeList.vue')
    },
    // 点位顺序
    {
      path: '/manage/pointOrderSetting',
      name: 'pointOrderSetting',
      meta: {
        name: '点位顺序',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/printQRCode/pointOrderSetting.vue')
    },
    // 巡检线路
    {
      path: '/manage/InspectionLineSetting',
      name: 'InspectionLineSetting',
      meta: {
        name: '巡检线路',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/printQRCode/InspectionLineSetting.vue')
    },
    // 添加/修改巡检线路
    {
      path: '/manage/addInspectionLineSetting',
      name: 'addInspectionLineSetting',
      meta: {
        name: '添加/修改巡检线路',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/printQRCode/addInspectionLineSetting.vue')
    },
    // 报表下载?
    {
      path: '/manage/main.tongji',
      name: 'reportManageList',
      meta: {
        name: '报表下载',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyDataService/reportDownloads/reportManageList.vue')
    },
    // 项目日历
    {
      path: '/manage/propertyProjectCalendar',
      name: 'propertyProjectCalendarList',
      meta: {
        name: '项目日历',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyDataService/projectCalendars/propertyProjectCalendarList.vue')
    },
    // APP梯控设备管理
    {
      path: '/manage/main.liftList',
      name: 'elevBluetoothEquipManagesList',
      meta: {
        name: 'APP梯控设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/elevBluetoothEquipManages/elevBluetoothEquipManagesList.vue')
    },
    // 星朗电梯蓝牙设备管理
    {
      path: '/manage/xlElevator',
      name: 'xlElevator',
      meta: {
        name: '电梯蓝牙设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/elevBluetoothEquipManages/xlElevator.vue')
    },
    // 合同分类
    {
      path: '/manage/main.contractType1',
      name: 'contractTypesList',
      meta: {
        name: '合同分类',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/contractTypeSetting/contractTypeManageList.vue')
    },
    // 物业知识库检索查询
    {
      path: '/manage/main.knowledge',
      name: 'searchAndQueryOfPropertyKnowledgeBaseList',
      meta: {
        name: '物业知识库检索查询',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/searchAndQueryOfPropertyKnowledgeBase/searchAndQueryOfPropertyKnowledgeBaseList.vue')
    },
    // 物业知识库分类管理
    {
      path: '/manage/main.knowledgeType',
      name: 'knowledgeBaseManagementList',
      meta: {
        name: '物业知识库分类管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/knowledgeBaseManagement/knowledgeBaseManagementList.vue')
    },
    // 电梯管理
    {
      path: '/manage/main.maintainElevatorErrorList',
      name: 'liftManagementList',
      meta: {
        name: '电梯管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/liftManagement/liftManagementList.vue')
    },
    // 电梯管理报事查看
    {
      path: '/manage/liftManagementInfo',
      name: 'liftManagementInfo',
      meta: {
        name: '电梯管理报事查看',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/liftManagement/liftManagementInfo.vue')
    },
    // 设备管理
    {
      path: '/manage/main.deviceList',
      name: 'deviceManagementList',
      meta: {
        name: '设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/deviceManagement/deviceManagementList.vue')
    },
    // 添加设备管理
    {
      path: '/manage/addDeviceManagement',
      name: 'addDeviceManagement',
      meta: {
        name: '添加设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/deviceManagement/addDeviceManagement.vue')
    },
    // 资源台账
    {
      path: '/manage/main.resourceLedgerList',
      name: 'resourceLedgerList',
      meta: {
        name: '资源台账',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/resourceLedger/resourceLedgerList.vue')
    },
    // 资源台账添加
    {
      path: '/manage/resourceLedgerAdd',
      name: 'resourceLedgerAdd',
      meta: {
        name: '资源台账添加',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/resourceLedger/resourceLedgerAdd.vue')
    },
    // 业主私信
    {
      path: '/manage/main.privateLetter',
      name: 'proprietorPrivateletterList',
      meta: {
        name: '业主私信',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorPrivateletter/proprietorPrivateletterList.vue')
    },
    // 业主端logo管理
    {
      path: '/manage/main.logo',
      name: 'proprietorLogoEdit',
      meta: {
        name: '业主端logo管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/proprietorLogo/proprietorLogoManageEdit.vue')
    },
    // 物业端logo管理
    {
      path: '/manage/main.wylogo',
      name: 'propertyLogoEdit',
      meta: {
        name: '物业端logo管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/propertyLogo/propertyLogoManageEdit.vue')
    },
    // 视频管理
    {
      path: '/manage/main.trainingVideoList',
      name: 'trainingVideoList',
      meta: {
        name: '视频管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/trainingVideo/trainingVideoList.vue')
    },
    // 视频分类管理
    {
      path: '/manage/trainingVideoTypeManagement',
      name: 'trainingVideoTypeManagement',
      meta: {
        name: '视频分类管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/trainingVideo/trainingVideoTypeManagement.vue')
    },
    // 部门管理
    {
      path: '/manage/main.dept',
      name: 'deptManagementList',
      meta: {
        name: '部门管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/deptManagement/deptManagementList.vue')
    },
    {
      path: '/manage/main.deptGroup',
      name: 'deptManagementGroupList',
      meta: {
        name: '集团部门管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/deptManagement/deptManagementGroupList.vue')
    },
    // 人脸设备管理
    {
      path: '/manage/main.woDeviceList',
      name: 'woDeviceManagementList',
      meta: {
        name: '人脸设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/woDeviceManagementList.vue')
    },
    // APP门禁设备管理
    {
      path: '/manage/main.doorDeviceList',
      name: 'accessControlEquipmentManagementList',
      meta: {
        name: 'APP门禁设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/accessControlEquipmentManagementList.vue')
    },
    // 门禁批量管理
    {
      path: '/manage/main.doorDeviceRightBatch',
      name: 'doorDeviceRightBatch',
      meta: {
        name: '门禁批量授权',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/doorDeviceRightBatch.vue')
    },
    // 梯控批量管理
    {
      path: '/manage/main.liftRightBatch',
      name: 'liftRightBatch',
      meta: {
        name: '梯控批量授权',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/liftRightBatch.vue')
    },
    // 子门禁设备管理
    {
      path: '/manage/doorDeviceSon',
      name: 'doorDeviceSon',
      meta: {
        name: '子门禁设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/doorDeviceSon.vue')
    },
    // 子门禁设备管理
    {
      path: '/manage/xlDevice',
      name: 'xlDevice',
      meta: {
        name: '子门禁设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/xlDevice.vue')
    },
    {
      path: '/manage/ycDevice',
      name: 'ycDevice',
      meta: {
        name: '子门禁设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/accessControlEquipmentManagement/ycDevice.vue')
    },
    // 检查标准
    {
      path: '/manage/main.patrolStandardList',
      name: 'InspectionStandardList',
      meta: {
        name: '检查标准',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/InspectionStandard/InspectionStandardList.vue')
    },
    // 检查标准复制
    {
      path: '/manage/main.copyPatrolStandardList',
      name: 'copyInspectionStandardList',
      meta: {
        name: '检查标准复制',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/InspectionStandard/copyInspectionStandardList.vue')
    },
    // 添加检查标准
    {
      path: '/manage/addInspectionStandard',
      name: 'addInspectionStandard',
      meta: {
        name: '添加检查标准',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/InspectionStandard/addInspectionStandard.vue')
    },
    // 检查标准分数
    {
      path: '/manage/patrolStandardPoint',
      name: 'patrolStandardPoint',
      meta: {
        name: '检查标准分数',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/InspectionStandard/InspectionStandardPoint.vue')
    },
    // 检查标准查看
    {
      path: '/manage/main.patrolStandardLookList',
      name: 'patrolStandardLookList',
      meta: {
        name: '检查标准查看',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/InspectionStandard/InspectionStandardLookList.vue')
    },
    // 人事信息
    {
      path: '/manage/main.hrList',
      name: 'personnelInformationList',
      meta: {
        name: '人事信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/estateManagement/personnelInformation/personnelInformationList.vue')
    },
    // 合同管理
    {
      path: '/manage/main.contract',
      name: 'contractManageList',
      meta: {
        name: '合同管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/contractManages/contractManageList.vue'),
    },
    // 编辑合同
    {
      path: '/manage/editContract',
      name: 'editContract',
      meta: {
        name: '编辑合同',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/contractManages/editContract.vue'),
    },
    // 合同记账
    {
      path: '/manage/setReminder',
      name: 'setReminder',
      meta: {
        name: '合同记账',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/contractManages/setReminder.vue'),
    },
    // 任务管理
    {
      path: '/manage/main.quartzJobList',
      name: 'taskManageList',
      meta: {
        name: '任务管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskManages/taskManageList.vue')
    },
    // 修改任务
    {
      path: '/manage/editTask',
      name: 'editTask',
      meta: {
        name: '修改任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskManages/editTask.vue')
    },
    // 电梯巡检计划任务
    {
      path: '/manage/main.taskImport',
      name: 'taskImport',
      meta: {
        name: '电梯巡检计划任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskManages/taskImport.vue')
    },
    // 稽查跨区任务管理
    {
      path: '/manage/main.quartzJobListInspect',
      name: 'taskInspectManageList',
      meta: {
        name: '稽查跨区任务管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskInspectManages/taskInspectManageList.vue')
    },
    // 稽查跨区修改任务
    {
      path: '/manage/editInspectTask',
      name: 'editInspectTask',
      meta: {
        name: '稽查跨区修改任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskInspectManages/editInspectTask.vue')
    },
    // 稽查跨区添加任务
    {
      path: '/manage/addInspectTask',
      name: 'addInspectTask',
      meta: {
        name: '稽查跨区添加任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskInspectManages/editInspectTask.vue')
    },
    // 物业人员管理
    {
      path: '/manage/main.staff',
      name: 'propertyManageList',
      meta: {
        name: '物业人员管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/propertyManages/propertyManageList.vue')
    },
    // 添加物业人员
    {
      path: '/manage/addpropertyManage',
      name: 'addpropertyManage',
      meta: {
        name: '添加物业人员',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/propertyManages/addpropertyManage.vue'),
    },
    // 管家区域配置
    {
      path: '/manage/main.housekeepingArea',
      name: 'housekeepingArea',
      meta: {
        name: '管家区域配置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/housekeepingArea/housekeepingArea.vue')
    },
    // 管家区域配置
    {
      path: '/manage/configHousekeepingArea',
      name: 'configHousekeepingArea',
      meta: {
        name: '管家区域配置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/housekeepingArea/configHousekeepingArea.vue'),
    },
    // 员工离职
    {
      path: '/manage/main.staffLeave',
      name: 'employeeTurnover',
      meta: {
        name: '员工离职',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/employeeTurnover/employeeTurnoverList.vue')
    },
    // 员工转单
    {
      path: '/manage/main.staffAdjustment',
      name: 'employeeTransferOrder',
      meta: {
        name: '员工转单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/employeeTransferOrder/employeeTransferOrderList.vue')
    },
    // 人员分配
    {
      path: '/manage/main.patrolPersonnelAllocationList',
      name: 'personnelList',
      meta: {
        name: '人员分配',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/personnelAllotment/personnelList.vue')
    },
    // 供应商
    {
      path: '/manage/main.supplierList',
      name: 'supplierList',
      meta: {
        name: '供应商',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/supplierManages/supplierList.vue')
    },
    // 标语管理
    {
      path: '/manage/main.sloganList',
      name: 'posterList',
      meta: {
        name: '标语管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/posterManages/posterList.vue')
    },
    // APP版本管理
    {
      path: '/manage/main.version',
      name: 'APPVersion',
      meta: {
        name: 'APP版本管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/appVersionManagement/APPVersion.vue')
    },
    // 添加APP版本
    {
      path: '/manage/addAppVersion',
      name: 'addAppVersion',
      meta: {
        name: '添加APP版本 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/appVersionManagement/addAppVersion.vue')
    },
    // Uniapp版本管理
    {
      path: '/manage/main.versionuniapp',
      name: 'UniappVersion',
      meta: {
        name: 'Uniapp版本管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/uniappVersionManagement/UniappVersion.vue')
    },
    // 添加Uniapp版本
    {
      path: '/manage/addUniappVersion',
      name: 'addUniappVersion',
      meta: {
        name: '添加Uniapp版本 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/uniappVersionManagement/addUniappVersion.vue')
    },
    // 活动管理
    {
      path: '/manage/main.activityList',
      name: 'activityManagementList',
      meta: {
        name: '活动管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/activityManagement/activityManagementList.vue')
    },
    // 添加活动
    {
      path: '/manage/addActivityManagement',
      name: 'addActivityManagement',
      meta: {
        name: '添加活动',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/activityManagement/addActivityManagement.vue')
    },
    // 活动参与详情
    {
      path: '/manage/seeActivityManagement',
      name: 'seeActivityManagement',
      meta: {
        name: '活动参与详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/activityManagement/seeActivityManagement.vue')
    },
    // 投票管理
    {
      path: '/manage/main.voteList',
      name: 'voteManager',
      meta: {
        name: '投票管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/voteManages/voteManager.vue')
    },
    // 红色专区
    {
      path: '/manage/main.redZone',
      name: 'redZoneList',
      meta: {
        name: '红色专区',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/redZoneManages/redZoneList.vue')
    },
    // 添加红色专区
    {
      path: '/manage/addRedZone',
      name: 'addRedZone',
      meta: {
        name: '添加',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/redZoneManages/addRedZone.vue')
    },
    // 小店广告
    {
      path: '/manage/main.sklGardenAd',
      name: 'sklGardenAdList',
      meta: {
        name: '小店广告',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/sklGardenAdManages/sklGardenAdList.vue')
    },
    // 小店广告添加
    {
      path: '/manage/addsklGardenAd',
      name: 'addsklGardenAd',
      meta: {
        name: '添加',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/sklGardenAdManages/addsklGardenAd.vue')
    },
    // 物品管理
    {
      path: '/manage/main.borrowingList',
      name: 'borrowingManager',
      meta: {
        name: '物品管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/borrowingManages/borrowingManager.vue')
    },
    // 物品记录管理
    {
      path: '/manage/borrowingRecordList',
      name: 'borrowingRecordList',
      meta: {
        name: '物品记录管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/borrowingManages/borrowingRecordList.vue')
    },
    // 链接管理
    {
      path: '/manage/main.linkManage',
      name: 'linkManagementList',
      meta: {
        name: '链接管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/linkManagement/linkManagementList.vue')
    },
    // 添加链接
    {
      path: '/manage/addLinkManagement',
      name: 'addLinkManagement',
      meta: {
        name: '添加链接',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/linkManagement/addLinkManagement.vue')
    },
    // 机房设备管理
    {
      path: '/manage/main.machineDeviceList',
      name: 'machineroom',
      meta: {
        name: '机房设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/machineroomManagement/machineroom.vue')
    },
    // 用后感
    {
      path: '/manage/main.testimonialsManage',
      name: 'useSensationList',
      meta: {
        name: '用后感',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/useSensation/useSensationList.vue')

    },
    // 项目日历
    {
      path: '/manage/main.patrolList',
      name: 'projectCalendarList',
      meta: {
        name: '项目日历',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/projectCalendar/projectCalendarList.vue')
    },
    // 类型设置
    {
      path: '/manage/main.patrolTypeList',
      name: 'typeList',
      meta: {
        name: '类型设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/typeManages/typeList.vue')
    },
    // 异常记录
    {
      path: '/manage/main.patrolExceptionList',
      name: 'patrolExceptionList',
      meta: {
        name: '异常记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/patrolException/patrolExceptionList.vue')
    },
    // 物业公司架构组织
    {
      path: '/manage/main.orgDepartment',
      name: 'useristratorsList',
      meta: {
        name: '物业公司架构组织',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/corporationManagement/userStrators/useristratorsList.vue')
    },
    // 添加组织
    {
      path: '/manage/addUserStratorsList',
      name: 'addUserStratorsList',
      meta: {
        name: '添加组织',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/corporationManagement/userStrators/addUserStratorsList.vue')
    },
    // 管理员列表
    {
      path: '/manage/main.adminList',
      name: 'administratorsList',
      meta: {
        name: '管理员列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/corporationManagement/administrators/administratorsList.vue')
    },
    // 添加管理员
    {
      path: '/manage/addAdminStrators',
      name: 'addAdminStrators',
      meta: {
        name: '添加管理员',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/corporationManagement/administrators/addAdminStrators.vue')
    },
    // 业主私信
    {
      path: '/manage/main.privateLetter',
      name: 'proprietorPrivateletterList',
      meta: {
        name: '业主私信',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorPrivateletter/proprietorPrivateletterList.vue')
    },
    // 业主通知
    {
      path: '/manage/main.unotice',
      name: 'proprietorNotificationList',
      meta: {
        name: '业主通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationList.vue')
    },
    // 添加通知
    {
      path: '/manage/proprietorNotificationAdd',
      name: 'proprietorNotificationAdd',
      meta: {
        name: '添加通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationEdit.vue')
    },
    // 编辑通知
    {
      path: '/manage/proprietorNotificationEdit',
      name: 'proprietorNotificationEdit',
      meta: {
        name: '编辑通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/proprietorNotification/proprietorNotificationEdit.vue')
    },
    // 集团网站维护
    {
      path: '/manage/main.groupWebsite',
      name: 'groupWebsiteList',
      meta: {
        name: '集团网站维护',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/groupWebsite/groupWebsiteList.vue')
    },
    // 集团网站注册审批
    {
      path: '/manage/main.groupExamine',
      name: 'groupExamine',
      meta: {
        name: '集团网站注册审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/groupExamine/groupExamine.vue')
    },
    // 添加新闻
    {
      path: '/manage/groupWebsiteAdd',
      name: 'groupWebsiteAdd',
      meta: {
        name: '添加新闻',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/groupWebsite/groupWebsiteEdit.vue')
    },
    // 编辑新闻
    {
      path: '/manage/groupWebsiteEdit',
      name: 'groupWebsiteEdit',
      meta: {
        name: '编辑新闻',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/neighborhoodService/groupWebsite/groupWebsiteEdit.vue')
    },

    // 物业信用积分体系
    {
      path: '/manage/main.creditScore',
      name: 'propertyCreditScoreList',
      meta: {
        name: '物业信用积分体系',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/propertyCreditScoreSys/propertyCreditScoreList.vue'),
    },
    // 评价等级列表
    {
      path: '/manage/propertyCreditScoreDetails',
      name: 'propertyCreditScoreDetails',
      meta: {
        name: '评价等级列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/propertyCreditScoreSys/propertyCreditScoreDetails.vue'),
    },
    // 好评列表
    {
      path: '/manage/propertyCreditScoreEvaluation',
      name: 'propertyCreditScoreEvaluation',
      meta: {
        name: '好评列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/propertyCreditScoreSys/propertyCreditScoreEvaluation.vue'),
    },
    // 小区管理
    {
      path: '/manage/main.gardensManage',
      name: 'communityManagementsList',
      meta: {
        name: '小区管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/communityManagements/communityManagementsList.vue')
    },
    // 添加小区
    {
      path: '/manage/communityManagementsadd',
      name: 'communityManagementsadd',
      meta: {
        name: '添加小区 ',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/communityManagements/communityManagementsadd.vue')
    },
    // 园区鹰眼接口
    {
      path: '/manage/main.videoMonitorInterface',
      name: 'eagleEyeList',
      meta: {
        name: '园区鹰眼接口',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/eagleEye/eagleEyeList.vue')
    },
    // 项目鹰眼接口
    {
      path: '/manage/main.videoMonitorInterfaceNew',
      name: 'eagleEyeListNew',
      meta: {
        name: '项目鹰眼接口',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/eagleEye/eagleEyeListNew.vue')
    },

    // 居家服务劳动所得
    {
      path: '/manage/main.serviceCommissionList',
      name: 'incomeHomeServiceLaborList',
      meta: {
        name: '居家服务劳动所得',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/incomeHomeServiceLabor/incomeHomeServiceLaborList.vue'),
    },
    // 居家服务
    {
      path: '/manage/incomeHomeServiceLaborDetails',
      name: 'incomeHomeServiceLaborDetails',
      meta: {
        name: '居家服务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/incomeHomeServiceLabor/incomeHomeServiceLaborDetails.vue'),
    },
    // 居家服务提成设置
    {
      path: '/manage/main.serviceCommissionExtract',
      name: 'homeServiceCommissionList',
      meta: {
        name: '居家服务提成设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/homeServiceCommission/homeServiceCommissionList.vue'),
    },
    // 集团管理
    {
      path: '/manage/main.groupsManage',
      name: 'groupsManageList',
      meta: {
        name: '集团管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityManagement/groupManagement/groupsManageList.vue')
    },
    // 系统管理
    {
      path: '/manage/systemService',
      name: 'systemService',
      meta: {
        name: '系统管理',
        icon: 'el-icon-star-off',
      },
      component: () => import('../views/systemService/systemService.vue'),
    },
    // 系统代码参数
    {
      path: '/manage/main.sysCode',
      name: 'systemCodeParametersList',
      meta: {
        name: '系统代码参数',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/systemCodeParameters/systemCodeParametersList.vue')
    },
    // 职务管理
    {
      path: '/manage/main.jobList',
      name: 'jobManagementList',
      meta: {
        name: '职务管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/jobManagement/jobManagementList.vue')
    },
    // 编辑职务
    {
      path: '/manage/editJobManagement',
      name: 'editJobManagement',
      meta: {
        name: '编辑职务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/jobManagement/editJobManagement.vue')
    },
    // 添加职务
    {
      path: '/manage/addJobManagement',
      name: 'addJobManagement',
      meta: {
        name: '添加职务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/jobManagement/editJobManagement.vue')
    },
    // 职责管理
    {
      path: '/manage/main.authorityList',
      name: 'responsibilityManagementList',
      meta: {
        name: '职责管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/responsibilityManagement/responsibilityManagementList.vue')
    },
    // 编辑职责
    {
      path: '/manage/editResponsibility',
      name: 'editResponsibility',
      meta: {
        name: '编辑职责',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/responsibilityManagement/editResponsibility.vue')
    },
    // 添加职责
    {
      path: '/manage/addResponsibility',
      name: 'addResponsibility',
      meta: {
        name: '添加职责',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/responsibilityManagement/editResponsibility.vue')
    },
    // 菜单管理
    {
      path: '/manage/main.munuManager',
      name: 'menuManagementList',
      meta: {
        name: '菜单管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/menuManagement/menuManagementList.vue')
    },
    // 角色管理
    {
      path: '/manage/main.roleList',
      name: 'roleManagementList',
      meta: {
        name: '角色管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/roleManagement/roleManagementList.vue')
    },
    // 编辑角色
    {
      path: '/manage/editRoleManagement',
      name: 'editRoleManagement',
      meta: {
        name: '编辑角色',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/roleManagement/editRoleManagement.vue')
    },
    // 添加角色
    {
      path: '/manage/addRoleManagement',
      name: 'addRoleManagement',
      meta: {
        name: '添加角色',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/systemService/roleManagement/editRoleManagement.vue')
    },
    // 商品管理
    {
      path: '/manage/main.sklShop',
      name: 'sklShop',
      meta: {
        name: '商品管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/sklShopManagement/sklShop.vue'),
    },
    // 商品标签
    {
      path: '/manage/main.sklTagManage',
      name: 'sklTagManage',
      meta: {
        name: '商品标签',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/sklShopManagement/sklTagManage/sklTagManage.vue')
    },
    // 考试管理
    {
      path: '/manage/main.exam',
      name: 'exam',
      meta: {
        name: '考试管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/examManagement/exam.vue'),
    },
    // 试题库
    {
      path: '/manage/main.exam_question',
      name: 'QuestionList',
      meta: {
        name: '试题库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/examManagement/question/QuestionList.vue')
    },
    // 试卷库
    {
      path: '/manage/main.exam_paper',
      name: 'PaperList',
      meta: {
        name: '试卷库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/examManagement/paper/PaperList.vue')
    },
    // 成绩库
    {
      path: '/manage/main.exam_result',
      name: 'ResultList',
      meta: {
        name: '成绩库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/examManagement/result/ResultList.vue')
    },
    // 分类设置
    {
      path: '/manage/main.exam_type',
      name: 'TypeSettings',
      meta: {
        name: '分类设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/examManagement/system/TypeSettings.vue')
    },
    {
      path: '/manage/main.lecturer_exam_question',
      name: 'lecturerQuestionList',
      meta: {
        name: '讲师试题库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/lecturerEvaluation/question/QuestionList.vue')
    },
    {
      path: '/manage/main.lecturerPaper',
      name: 'lecturerPaperList',
      meta: {
        name: '讲师试卷库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/lecturerEvaluation/paper/PaperList.vue')
    },
    {
      path: '/manage/main.lecturerResult',
      name: 'lecturerResultList',
      meta: {
        name: '讲师成绩库',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/lecturerEvaluation/result/ResultList.vue')
    },
    {
      path: '/manage/main.lecturerType',
      name: 'lecturerTypeSettings',
      meta: {
        name: '讲师分类设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/lecturerEvaluation/system/TypeSettings.vue')
    },
    // 收费管理
    {
      path: '/manage/main.fee',
      name: 'fee',
      meta: {
        name: '收费管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeManagement.vue'),
    },
    // 收费设置
    {
      path: '/manage/main.feeConfig',
      name: 'feeConfigList',
      meta: {
        name: '收费设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeConfig/feeConfigList.vue')
    },
     // 收费设置
    {
      path: '/manage/main.invoicingCompany',
      name: 'invoicingCompany',
      meta: {
        name: '开票公司配置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeConfig/feeInvoicingCompany.vue')
    },
    {
      path: '/manage/main.feeBasic',
      name: 'feeBasicData',
      meta: {
        name: '计费数据',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feeBasicData.vue')
    },
    // 房屋收费
    {
      path: '/manage/main.feePay',
      name: 'feePayList',
      meta: {
        name: '房屋收费',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feePayList.vue')
    },
    // 房屋收费明细
    {
      path: '/manage/feeRoomList',
      name: 'feeRoomList',
      meta: {
        name: '房屋收费明细',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feeRoomList.vue')
    },
    // 房屋收费明细
    {
      path: '/manage/feePay',
      name: 'feePay',
      meta: {
        name: '房屋收费明细',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feePay.vue')
    },
        {
      path: '/manage/feeCombinedPay',
      name: 'feeCombinedPay',
      meta: {
        name: '房屋收费明细',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feeCombinedPay.vue')
    },
    // 房屋收费明细
    {
      path: '/manage/feeProperty',
      name: 'feeProperty',
      meta: {
        name: '房屋收费明细',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feePay/feeProperty.vue')
    },
    // 应收查询
    {
      path: '/manage/main.feeReceive',
      name: 'feeReceiveQuery',
      meta: {
        name: '应收查询',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeQuery/feeReceiveQuery.vue')
    },
    {
      path: '/manage/main.feeActual',
      name: 'feeActualQuery',
      meta: {
        name: '实收查询',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeQuery/feeActualQuery.vue')
    },
    {
      path: '/manage/main.feeReport',
      name: 'feeReport',
      meta: {
        name: '报表管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReportQuery.vue')
    },
    {
      path: '/manage/main.feeStatistics',
      name: 'feeStatistics',
      meta: {
        name: '报表统计',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReportQueryStatistics.vue')
    },
    {
      path: '/manage/collectionRateDetail',
      name: 'collectionRateDetail',
      meta: {
        name: '收缴率统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/collectionRateDetail.vue')
    },
    {
      path: '/manage/feeReceiveArrears',
      name: 'feeReceiveArrears',
      meta: {
        name: '欠费统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReceiveArrearsQuery.vue')
    },
    {
      path: '/manage/feeReceivableRoomAndCar',
      name: 'feeReceivableRoomAndCar',
      meta: {
        name: '应收统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReceivableRoomAndCarQuery.vue')
    },
    {
      path: '/manage/feeReliefDetail',
      name: 'feeReliefDetail',
      meta: {
        name: '减免统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReliefDetailQuery.vue')
    },
    {
      path: '/manage/feeAdvanceReceiptDetail',
      name: 'feeAdvanceReceiptDetail',
      meta: {
        name: '预收统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeAdvanceReceiptDetailQuery.vue')
    },
    {
      path: '/manage/feeReturnDetail',
      name: 'feeReturnDetail',
      meta: {
        name: '退费统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReturnDetailQuery.vue')
    },
    {
      path: '/manage/collectionRateDetaiTarget',
      name: 'collectionRateDetaiTarget',
      meta: {
        name: '目标值统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/collectionRateDetaiTarget.vue')
    },
    {
      path: '/manage/monthCollectOutside',
      name: 'monthCollectOutside',
      meta: {
        name: '月度实收报表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/monthCollectOutside.vue')
    },
    {
      path: '/manage/collectionRateDetailStatistics',
      name: 'collectionRateDetailStatistics',
      meta: {
        name: '收缴率统计表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/collectionRateDetailStatistics.vue')
    },
    {
      path: '/manage/feeReceiptsDetail',
      name: 'feeReceiptsDetail',
      meta: {
        name: '实收明细表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeReceiptsDetailQuery.vue')
    },
    {
      path: '/manage/invoiceDetail',
      name: 'invoiceDetail',
      meta: {
        name: '开票明细表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeReport/feeInvoiceDetailQuery.vue')
    },
    {
      path: '/manage/main.voucher',
      name: 'feeReport',
      meta: {
        name: '实收汇总单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeVoucher/feeVoucherQuery.vue')
    },
    {
      path: '/manage/main.feeInitialization',
      name: 'feeInitialization',
      meta: {
        name: '期初导入',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeInitialization/feeInitializationList.vue')
    },
    {
      path: '/manage/main.feeBatchList',
      name: 'feeBatchList',
      meta: {
        name: '批量导入',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeInitialization/feeBatchList.vue')
    },
    ,
    {
      path: '/manage/main.feeBill',
      name: 'feeBill',
      meta: {
        name: '票据管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/feeManagement/feeConfig/feeBill.vue')
    },
    // 外拓信息管理列表
    {
      path: '/manage/main.outSide',
      name: 'outSide',
      meta: {
        name: '外拓信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/outSide/outSideList.vue')
    },
    // 外拓信息新增&修改
    {
      path: '/manage/main.outSideEdit',
      name: 'outSideEdit',
      meta: {
        name: '外拓信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/outSide/outSideEdit.vue')
    },
    // 临时停车缴费
    {
      path: '/manage/main.payStop',
      name: 'payStop',
      meta: {
        name: '商家优惠停车',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/payStop/payStop.vue')
    },
    {
      path: '/manage/main.payStopDerate',
      name: 'payStopDerate',
      meta: {
        name: '商家优惠减免',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/payStop/payStopDerate.vue')
    },
    // 资源点位管理
    {
      path: '/manage/main.venueList',
      name: 'venueList',
      meta: {
        name: '资源点位管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/venueList.vue')
    },
    // 添加资源点位
    {
      path: '/manage/main.venueForm',
      name: 'venueForm',
      meta: {
        name: '添加资源点位',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/venueForm.vue')
    },
    // 资源点位类型管理
    {
      path: '/manage/main.venueType',
      name: 'venuType',
      meta: {
        name: '资源点位类型管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/venueType.vue')
    },
    // 综合评估
    {
      path: '/manage/main.empAssessmentForm',
      name: 'empAssessmentForm',
      meta: {
        name: '员工自评',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/comprehensive/empAssessmentForm/empAssessmentForm.vue')
    },
    {
      path: '/manage/main.superiorAssessmentFormList',
      name: 'superiorAssessmentFormList',
      meta: {
        name: '我的部门员工自评列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/comprehensive/superiorAssessmentFormList/superiorAssessmentFormList.vue')
    },
    {
      path: '/manage/main.superiorAssessmentForm',
      name: 'superiorAssessmentForm',
      meta: {
        name: '我的评审',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/comprehensive/superiorAssessmentFormList/superiorAssessmentForm.vue')
    },
    {
      path: '/manage/main.zljexe',
      name: 'zljexe',
      meta: {
        name: '众乐家外部应用',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/zljexe/zljexe.vue')
    },
    // 星朗发卡管理列表
    {
      path: '/manage/main.manageCardList',
      name: 'manageCardList',
      meta: {
        name: '发卡管理列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/xinglang/manageCard/manageCardList.vue')
    },
    // 新增发卡
    {
      path: '/manage/main.manageCardAdd',
      name: 'manageCardAdd',
      meta: {
        name: '新增发卡',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/xinglang/manageCard/manageCardAdd.vue')
    },
    // 星朗门禁设备管理
    {
      path: '/manage/main.xlDoorDevice',
      name: 'xlDoorDevice',
      meta: {
        name: '星朗门禁设备管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/xinglang/xlDoorDevice/xlDoorDevice.vue')
    },
    // 万洁公司新闻列表
    {
      path: '/manage/main.wjNewsList',
      name: 'wjNewsList',
      meta: {
        name: '公司新闻',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjNews/wjNewsList.vue')
    },
    // 万洁公司新闻新增修改
    {
      path: '/manage/main.wjNewsEdit',
      name: 'wjNewsEdit',
      meta: {
        name: '新增新闻',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjNews/wjNewsEdit.vue')
    },
    // 万洁技能培训列表
    {
      path: '/manage/main.wjTrainList',
      name: 'wjTrainList',
      meta: {
        name: '技能培训',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjTrain/wjTrainList.vue')
    },
    // 万洁技能培训新增编辑
    {
      path: '/manage/main.wjTrainEdit',
      name: 'wjTrainEdit',
      meta: {
        name: '新增培训',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjTrain/wjTrainEdit.vue')
    },
    // 万洁任务管理
    {
      path: '/manage/main.wjTaskManageList',
      name: 'wjTaskManageList',
      meta: {
        name: '工作任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjTaskManages/wjTaskManageList.vue')
    },
    // 万洁修改任务
    {
      path: '/manage/main.wjEditTask',
      name: 'wjEditTask',
      meta: {
        name: '修改任务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjTaskManages/wjEditTask.vue')
    },
    // 万洁任务标准
    {
      path: '/manage/main.wjPatrolStandardList',
      name: 'wjPatrolStandardList',
      meta: {
        name: '任务标准',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjPatrolStandard/wjPatrolStandardList.vue')
    },
    // 添加检查标准
    {
      path: '/manage/wjAddInspectionStandard',
      name: 'wjAddInspectionStandard',
      meta: {
        name: '添加检查标准',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjPatrolStandard/wjAddInspectionStandard.vue')
    },
    // 检查标准查看
    {
      path: '/manage/main.wjPatrolStandardLookList',
      name: 'wjPatrolStandardLookList',
      meta: {
        name: '任务标准查看',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjPatrolStandard/wjPatrolStandardLookList.vue')
    },
    // 星朗密钥管理
    {
      path: '/manage/main.secretManage',
      name: 'secretManage',
      meta: {
        name: '密钥管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/xlSecretManage/xlSecretManage.vue')
    },
    // 御琥阁精品展示列表
    {
      path: '/manage/main.productShow',
      name: 'productShow',
      meta: {
        name: '产品展示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/yhgProductShowList.vue')
    },
    // 御琥阁精品展示添加、修改
    {
      path: '/manage/main.productShowAdd',
      name: 'productShowAdd',
      meta: {
        name: '产品展示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/yhgProductShowAdd.vue')
    },
    // 御琥阁普品展示列表
    {
      path: '/manage/main.productShow1',
      name: 'productShow1',
      meta: {
        name: '产品展示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/yhgProductShowList1.vue')
    },
    // 御琥阁普品展示添加、修改
    {
      path: '/manage/main.productShowAdd1',
      name: 'productShowAdd1',
      meta: {
        name: '产品展示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/yhgProductShowAdd1.vue')
    },
    // 御琥阁预约设置
    {
      path: '/manage/main.appointSetting',
      name: 'appointSetting',
      meta: {
        name: '预约设置',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/appointSetting.vue')
    },
    // 御琥阁预约列表
    {
      path: '/manage/main.appointList',
      name: 'appointList',
      meta: {
        name: '预约列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/appointList.vue')
    },
    // 御琥阁产品证书列表
    {
      path: '/manage/main.certificateList',
      name: 'certificateList',
      meta: {
        name: '产品证书',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/certificateList.vue')
    },
    // 御琥阁产品证书新增编辑
    {
      path: '/manage/main.certificateAdd',
      name: 'certificateAdd',
      meta: {
        name: '产品证书',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhgProduct/certificateAdd.vue')
    },
    // 万洁预约审批列表
    {
      path: '/manage/main.wjAppointmentExamine',
      name: 'wjAppointmentExamine',
      meta: {
        name: '预约审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjAppointment/wjAppointmentExamine.vue')
    },
    // 万洁预约数据导出
    {
      path: '/manage/main.wjAppointmentExamine1',
      name: 'wjAppointmentExamine1',
      meta: {
        name: '预约审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjAppointment/wjAppointmentExamine1.vue')
    },
    // 万洁预约审批详情
    {
      path: '/manage/main.wjAppointmentEdit',
      name: 'wjAppointmentExamineEdit',
      meta: {
        name: '预约审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjAppointment/wjAppointmentEdit.vue')
    },
    // 万洁货物配送审批详情
    {
      path: '/manage/main.wjAppointmentEdit1',
      name: 'wjAppointmentExamineEdit1',
      meta: {
        name: '货物配送',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/wanjie/wjAppointment/wjAppointmentEdit1.vue')
    },
    // 项目画像projectPortrait
    {
      path: '/manage/main.projectPortrait',
      name: 'projectPortrait',
      meta: {
        name: '项目画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/projectPortrait.vue')
    },
    // 企业党组织建设情况
    {
      path: '/manage/main.enterpriseParty',
      name: 'enterpriseParty',
      meta: {
        name: '企业党组织建设情况',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/enterpriseParty.vue')
    },
    // 企业党组织建设情况
    {
      path: '/manage/main.gardenParty',
      name: 'gardenParty',
      meta: {
        name: '小区党组织建设情况',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/gardenParty.vue')
    },
    // 物业企业信息管理
    {
      path: '/manage/main.propertyEnterpriseInfo',
      name: 'propertyEnterpriseInfo',
      meta: {
        name: '物业企业信息管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/propertyEnterpriseInfo.vue')
    },
    // 物业企业信息管理-添加人员基本信息
    {
      path: '/manage/main.addPropertyEnterprisePeopleInfo',
      name: 'addPropertyEnterprisePeopleInfo',
      meta: {
        name: '添加人员基本信息',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/addPropertyEnterprisePeopleInfo.vue')
    },
    // 物业服务合同管理
    {
      path: '/manage/main.propertyContractList',
      name: 'propertyContractList',
      meta: {
        name: '物业服务合同管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/propertyContractList.vue')
    },
    // 新增物业服务合同
    {
      path: '/manage/main.propertyContractAdd',
      name: 'propertyContractAdd',
      meta: {
        name: '新增物业服务合同',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/propertyContractAdd.vue')
    },
    // 小区负责人管理
    {
      path: '/manage/main.addLeaderInfo',
      name: 'addLeaderInfo',
      meta: {
        name: '小区负责人管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/addLeaderInfo.vue')
    },
    // 小区服务人员管理
    {
      path: '/manage/main.addServiceInfo',
      name: 'addServiceInfo',
      meta: {
        name: '小区服务人员管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/addServiceInfo.vue')
    },
    // 物业小区信息管理
    {
      path: '/manage/main.gardenInfoAdministration',
      name: 'gardenInfoAdministration',
      meta: {
        name: '物业小区信息管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/projectPortrait/gardenInfoAdministration.vue')
    },
    // 党建服务-党建活动
    {
      path: '/manage/main.partyActivityList',
      name: 'partyActivityList',
      meta: {
        name: '党建活动列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/partyService/partyActivity/partyActivityList.vue')
    },
    // 党建服务-党建活动新增
    {
      path: '/manage/main.partyActivityAdd',
      name: 'partyActivityAdd',
      meta: {
        name: '党建活动新增',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/partyService/partyActivity/partyActivityAdd.vue')
    },
    // 离职待处理工单列表
    {
      path: '/manage/main.leaveUntreatedOrderList',
      name: 'leaveUntreatedOrderList',
      meta: {
        name: '离职待处理工单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/leaveUntreatedOrder/leaveUntreatedOrderList.vue')
    },
    // 离职待处理工单详情
    {
      path: '/manage/main.leaveUntreatedOrderDetail',
      name: 'leaveUntreatedOrderDetail',
      meta: {
        name: '离职待处理工单详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/leaveUntreatedOrder/leaveUntreatedOrderDetail.vue')
    },
    // 跑马灯通知
    {
      path: '/manage/main.racNotice',
      name: 'racNotice',
      meta: {
        name: '跑马灯通知',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/racNotice/racNoticeList.vue')
    },
    // 电梯物联网实时监测列表
    {
      path: '/manage/main.realTimeMonitoringList',
      name: 'realTimeMonitoringList',
      meta: {
        name: '实时监测',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/realTimeMonitoringList.vue')
    },
    // 电梯物联网集中监测列表
    {
      path: '/manage/main.focusMonitoringList',
      name: 'focusMonitoringList',
      meta: {
        name: '集中监测',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/focusMonitoringList.vue')
    },
    // 电梯物联网电梯画像
    {
      path: '/manage/main.elevatorPortray',
      name: 'elevatorPortray',
      meta: {
        name: '电梯画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/elevatorPortray.vue')
    },
    // 电梯物联网电梯详情
    {
      path: '/manage/main.elevatorDetail',
      name: 'elevatorDetail',
      meta: {
        name: '电梯详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/elevatorDetail.vue')
    },
    // 电梯物联网设备列表
    {
      path: '/manage/main.elevatorList',
      name: 'elevatorList',
      meta: {
        name: '设备列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/elevatorList.vue')
    },
    // 电梯物联网电梯告警
    {
      path: '/manage/main.elevatorAlarm',
      name: 'elevatorAlarm',
      meta: {
        name: '电梯告警',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/elevatorAlarm.vue')
    },
    // 电梯物联网实时监测详情
    {
      path: '/manage/main.realTimeMonitoringDetail',
      name: 'realTimeMonitoringDetail',
      meta: {
        name: '实时监测',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/realTimeMonitoringDetail.vue')
    },
    // 电梯物联网设备参数读取
    {
      path: '/manage/main.deviceRead',
      name: 'deviceRead',
      meta: {
        name: '设备参数读取',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/deviceRead.vue')
    },
    // 电瓶车阻梯参数读取
    {
      path: '/manage/main.cableCarRead',
      name: 'cableCarRead',
      meta: {
        name: '电瓶车阻梯参数读取',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/cableCarRead.vue')
    },
    // 电梯开关门参数参数读取
    {
      path: '/manage/main.doorRead',
      name: 'doorRead',
      meta: {
        name: '电瓶车阻梯参数读取',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/elevatorInternet/doorRead.vue')
    },
    // 资源点位供应商管理
    {
      path: '/manage/main.vesupplierList',
      name: 'vesupplierList',
      meta: {
        name: '供应商管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/vesupplierList.vue')
    },
    // 资源点位供应商添加
    {
      path: '/manage/main.vesupplierAdd',
      name: 'vesupplierAdd',
      meta: {
        name: '资源点位供应商管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/vesupplierAdd.vue')
    },
    // 资源点位合同管理
    {
      path: '/manage/main.contractList',
      name: 'contractList',
      meta: {
        name: '合同管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/contractList.vue')
    },
    // 资源点位合同管理添加
    {
      path: '/manage/main.contractAdd',
      name: 'contractAdd',
      meta: {
        name: '资源点位合同管理添加',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/venue/contractAdd.vue')
    },
    // Nas网络存储服务
    {
      path: '/manage/main.serviceNas',
      name: 'serviceNas',
      meta: {
        name: 'Nas网络存储服务',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/serviceNas/serviceNas.vue')
    },
    // 基础数据汇总
    {
      path: '/manage/main.basicDataSummarys',
      name: 'basicDataSummarys',
      meta: {
        name: '园区数字画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/basicData/basicDataSummarys.vue')
    },
    // 基础数据汇总
    {
      path: '/manage/main.basicDataSummary',
      name: 'basicDataSummary1',
      meta: {
        name: '园区数字画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/basicData/basicDataSummary.vue')
    },
    // pdf打印
    {
      path: '/manage/pdfPrint',
      name: 'pdfPrint',
      meta: {
        name: 'pdf打印',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/pdfPrint.vue')
    },
    // 园区鹰眼回放
    {
      path: '/manage/main.supplyVideoPb',
      name: 'hawkEyePlayBack',
      meta: {
        name: '园区鹰眼',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/hawkEyeOfPark/hawkEyePlayBack.vue')
    },
    // 教育公司活动管理
    {
      path: '/manage/main.teachGroupList',
      name: 'teachGroupList',
      meta: {
        name: '教育活动管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/teachGroup/teachGroupList.vue')
    },
    // 教育添加活动
    {
      path: '/manage/addTeachGroup',
      name: 'addTeachGroup',
      meta: {
        name: '添加活动',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/teachGroup/addTeachGroup.vue')
    },
    // 教育活动参团列表
    {
      path: '/manage/groupManagement',
      name: 'groupManagement',
      meta: {
        name: '活动参与详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/teachGroup/groupManagement.vue')
    },
    // 教育活动参团人员列表
    {
      path: '/manage/joinManagement',
      name: 'joinManagement',
      meta: {
        name: '活动参与详情',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/other/teachGroup/joinManagement.vue')
    },
    // 物业人员画像
    {
      path: '/manage/main.staffSummary',
      name: 'staffSummary',
      meta: {
        name: '物业人员画像',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/propertyManages/staffSummary.vue')
    },
    // 物业人员数据对比
    {
      path: '/manage/main.staffSummaryPk',
      name: 'staffSummaryPk',
      meta: {
        name: '物业人员画像对比',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/propertyManages/staffSummaryPk.vue')
    },
    // 园区数字画像对比
    {
      path: '/manage/main.basicDataSummaryPk',
      name: 'basicDataSummaryPk',
      meta: {
        name: '园区数字画像对比',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/basicData/basicDataSummaryPk.vue')
    },
    // 行为指标管理
    {
      path: '/manage/main.behaviorTagretList',
      name: 'behaviorTagretList',
      meta: {
        name: '行为指标管理',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/behaviorTagret/behaviorTagretList.vue')
    },
    // 行为指标录入
    {
      path: '/manage/main.behaviorTagretAdd',
      name: 'behaviorTagretAdd',
      meta: {
        name: '行为指标录入',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/behaviorTagret/behaviorTagretAdd.vue')
    },
    {
      path: '/manage/main.sysLogOperate',
      name: 'sysLogOperate',
      meta: {
        name: '系统操作日志',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/syslog/sysLogOperate.vue')
    },
    {
      path: '/manage/main.videoRecord',
      name: 'videoRecord',
      meta: {
        name: '监控回放',
        icon: 'el-icon-camera'
      },
      component: () => import('../views/cameraPlayer/record/index.vue')
    },
    // 计划任务模板列表
    {
      path: '/manage/main.taskTemplateList',
      name: 'taskTemplateList',
      meta: {
        name: '计划任务模板列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskManages/taskTemplateList.vue')
    },
    // 修改任务模板
    {
      path: '/manage/taskTemplateAdd',
      name: 'taskTemplateAdd',
      meta: {
        name: '计划任务模板新增',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/taskManages/taskTemplateAdd.vue')
    },
    // 重点工作列表
    {
      path: '/manage/main.mainWorkList',
      name: 'mainWorkList',
      meta: {
        name: '重点工作列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/propertyManagementService/mainWork/mainWorkList.vue')
    },
    // 原始住户修改审批
    {
      path: '/manage/main.basicInfoApproval',
      name: 'basicInfoApproval',
      meta: {
        name: '原始住户修改审批',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/communityInformation/basicInfoApproval/basicInfoApproval.vue')
    },
    // 外拓演示
    {
      path: '/manage/main.outsideShow',
      name: 'outsideShow',
      meta: {
        name: '外拓演示',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/outsideShow/outsideShow.vue')
    },
    // 审阅&抽审问题工单列表
    {
      path: '/manage/main.questionOrder',
      name: 'questionOrder',
      meta: {
        name: '审阅&抽审问题工单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/questionOrder/questionOrderList.vue')
    },
    // 审阅&抽审问题工单详情
    {
      path: '/manage/main.questionOrderDetail',
      name: 'questionOrderDetail',
      meta: {
        name: '审阅&抽审问题工单',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/questionOrder/questionOrderDetail.vue')
    },
    // 常用语列表
    {
      path: '/manage/main.commonPhrasesList',
      name: 'commonPhrasesList',
      meta: {
        name: '常用语列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/reportingModule/commonPhrases/commonPhrasesList.vue')
    },
    // -----------------------大会员系统----------------------------
    // 楼层列表
    {
      path: '/manage/main.yhHouseManageList',
      name: 'yhHouseManageList',
      meta: {
        name: '楼层列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhHouseManage/yhHouseManageList.vue')
    },
    // 商户列表
    {
      path: '/manage/main.yhStoreManageList',
      name: 'yhStoreManageList',
      meta: {
        name: '商户列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhStoreManage/yhStoreManageList.vue')
    },
    // 商户新增编辑
    {
      path: '/manage/main.yhStoreManageAdd',
      name: 'yhStoreManageAdd',
      meta: {
        name: '商户新增编辑',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhStoreManage/yhStoreManageAdd.vue')
    },
    // 广告活动列表
    {
      path: '/manage/main.yhAdvertisingManageList',
      name: 'yhAdvertisingManageList',
      meta: {
        name: '广告活动列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhAdvertisingManage/yhAdvertisingManageList.vue')
    },
    // 广告活动新增编辑
    {
      path: '/manage/main.yhAdvertisingManageAdd',
      name: 'yhAdvertisingManageAdd',
      meta: {
        name: '广告活动新增编辑',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhAdvertisingManage/yhAdvertisingManageAdd.vue')
    },
    // 会员活动列表
    {
      path: '/manage/main.yhMemberActivitiesManageList',
      name: 'yhMemberActivitiesManageList',
      meta: {
        name: '会员活动列表',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhMemberActivitiesManage/yhMemberActivitiesManageList.vue')
    },
    // 会员活动新增编辑
    {
      path: '/manage/main.yhMemberActivitiesManageAdd',
      name: 'yhMemberActivitiesManageAdd',
      meta: {
        name: '会员活动新增编辑',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/yhMemberManage/yhMemberActivitiesManage/yhMemberActivitiesManageAdd.vue')
    },
    // 车场商家发券
    {
      path: '/manage/main.storeCoupons',
      name: 'storeCoupons',
      meta: {
        name: '停车场商家发券',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/storeCoupons/storeCoupons.vue')
    },
    // 发券记录
    {
      path: '/manage/main.storeCouponsHistory',
      name: 'storeCouponsHistory',
      meta: {
        name: '停车场商家发券记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/storeCoupons/storeCouponsHistory.vue')
    },
    // 使用记录
    {
      path: '/manage/main.storeCouponsRecord',
      name: 'storeCouponsRecord',
      meta: {
        name: '使用记录',
        icon: 'el-icon-star-off'
      },
      component: () => import('../views/car/storeCoupons/storeCouponsRecord.vue')
    }
  ]
}, {
  path: '/auth',
  name: 'auth',
  component: () => import('../views/login/auth.vue'),
}]
// 写一个更改方法 可以再页面上更改router
export var menus = manageRoutes[0].children.slice(1)

// 解决同一路径被点击2次就报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  // base: '/backWeb/', // 测试打开

  routes: [
    ...loginRoutes,
    ...printRoutes,
    ...manageRoutes
  ]
})
